import Vue from 'vue';
import items from './items';

const success = (response, resolve) => {
  items(1, 5);
  resolve(response);
};

const failed = (error, reject) => {
  reject(error);
};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.delete(`/client_groups/${id}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/client-group/destroy.js